<div class="bulk-bar" role="toolbar" aria-label="Bulk actions">
  <span class="bulk-count" [dataSelector]="'cxp-crl-bulk-count'">{{ selectedCount() }} selected</span>

  <div class="bulk-actions">
    <button
      andButton
      color="primary"
      size="small"
      [disabled]="!hasSelection()"
      [dataSelector]="'cxp-crl-bulk-mark-finished'"
      (click)="onAction(bulkAction.MARK_FINISHED)"
    >Mark Finished</button>

    <button
      andButton
      color="default"
      size="small"
      [disabled]="!hasSelection()"
      [dataSelector]="'cxp-crl-bulk-mark-na'"
      (click)="onAction(bulkAction.MARK_NOT_APPLICABLE)"
    >Mark N/A</button>

    <button
      andButton
      color="default"
      size="small"
      [disabled]="!hasSelection()"
      [dataSelector]="'cxp-crl-bulk-reassign'"
      (click)="onAction(bulkAction.REASSIGN)"
    >Reassign</button>
  </div>

  <button
    andButton
    color="ghost"
    size="small"
    class="bulk-done"
    [dataSelector]="'cxp-crl-bulk-done'"
    (click)="done.emit()"
  >Done</button>
</div>
